import Dashboard from "./components/Dashboard.vue";
import PazienteMisurazioniExportList from "./pages/PazienteMisurazioniExportList.vue"

export default {
    Dashboard,
    PazienteMisurazioniExportList,
};
